<!--我的页面-->
<template>
    <div class="idS">
        <van-tabs v-model="active" @change="onChange" background="#000" title-active-color="#ffffff"
            title-inactive-color="#888" color="#dfdfdf" :swipeable="false">
            <van-tab v-for="(item, index) in dataList" :key="index" :title="item.name">
                <div class="overview">
                    <div class="total">{{ $t('当前共有') }}<span>{{ totalS }}</span>{{ $t('条记录') }}</div>
                    <div class="amount" v-if="active == 2">
                        <div class="rowItem">
                            <div>{{ $t('已借金额') }}(USDT)</div>
                            <div>{{ objectS.borrow }}</div>
                        </div>
                        <div class="rowItem">
                            <div>{{ $t('剩余还币数量') }}(USDT)</div>
                            <div>{{ objectS.repay }}</div>
                        </div>
                        <div class="rowItem">
                            <div>{{ $t('已还') }}(USDT)</div>
                            <div>{{ objectS.pecent }}</div>
                        </div>
                    </div>
                    <div class="table" v-if="active == 0 || active == 1">
                        <!-- 表头 -->
                        <van-row class="header">
                            <van-col span="6" class="vanItem">{{ $t('时间') }}</van-col>
                            <van-col span="4" class="vanItem">{{ $t('币种') }}</van-col>
                            <van-col span="5" class="vanItem">{{ $t('数量') }}</van-col>
                            <van-col span="5" class="vanItem">{{ $t('手续') }}</van-col>
                            <van-col span="4" class="vanItem">{{ $t('状态') }}</van-col>
                        </van-row>
                        <!-- 数据 -->
                        <div class="scroll">
                            <van-row v-for="item in orderList" :key="item.id" class="row">
                                <van-col span="6" class="trade">
                                    {{ item.createtime_text }}
                                </van-col>
                                <van-col span="4" class="trade">
                                    <div v-if="active == 0">
                                        {{ item.unit_received }}
                                    </div>
                                    <div v-if="active == 1">
                                        {{ item.unit }}
                                    </div>
                                </van-col>
                                <van-col span="5" class="trade">
                                    {{ item.amount_received }}
                                </van-col>
                                <van-col span="5" class="trade">
                                    {{ item.fee }}
                                </van-col>
                                <van-col span="4" class="trade">
                                    {{ item.status_text }}
                                </van-col>
                            </van-row>
                        </div>
                    </div>
                    <div class="table" v-if="active == 2">
                        <!-- 表头 -->
                        <van-row class="header">
                            <van-col span="4" class="vanItem">{{ $t('借币数量') }}</van-col>
                            <van-col span="4" class="vanItem">{{ $t('验资金额') }}</van-col>
                            <van-col span="4" class="vanItem">{{ $t('日币利息') }}</van-col>
                            <van-col span="4" class="vanItem">{{ $t('当前币息') }}</van-col>
                            <van-col span="4" class="vanItem">{{ $t('总服务费') }}</van-col>
                            <van-col span="4" class="vanItem">{{ $t('应还总额') }}</van-col>
                        </van-row>
                        <!-- 数据 -->
                        <div class="scroll">
                            <van-row v-for="item in orderList" :key="item.id" class="row">
                                <van-col span="4" class="trade">
                                    {{ item.amount }}
                                </van-col>
                                <van-col span="4" class="trade">
                                    {{ item.money }}
                                </van-col>
                                <van-col span="4" class="trade">
                                    {{ item.daily_interest_rate }}%
                                </van-col>
                                <van-col span="4" class="trade">
                                    {{ item.interest_amount }}%
                                </van-col>
                                <van-col span="4" class="trade">
                                    {{ item.service_charge }}
                                </van-col>
                                <van-col span="4" class="trade">
                                    {{ item.all_money }}
                                </van-col>
                            </van-row>
                        </div>
                    </div>
                    <div class="table" v-if="active == 3">
                        <!-- 表头 -->
                        <van-row class="header">
                            <van-col span="4" class="vanItem">{{ $t('币种') }}</van-col>
                            <van-col span="4" class="vanItem">{{ $t('方向') }}</van-col>
                            <van-col span="4" class="vanItem">{{ $t('总数量') }}</van-col>
                            <van-col span="4" class="vanItem">{{ $t('委托价格') }}</van-col>
                            <van-col span="4" class="vanItem">{{ $t('成交价格') }}</van-col>
                            <van-col span="4" class="vanItem">{{ $t('类型') }}</van-col>
                        </van-row>
                        <!-- 数据 -->
                        <div class="scroll">
                            <van-row v-for="item in orderList" :key="item.id" class="row">
                                <van-col span="4" class="trade">
                                    {{ item.title }}
                                </van-col>
                                <van-col span="4" class="trade" style="color: aqua;">
                                    {{ item.direction_text }}
                                </van-col>
                                <van-col span="4" class="trade">
                                    {{ item.number }}
                                </van-col>
                                <van-col span="4" class="trade">
                                    {{ item.limit_price }}
                                </van-col>
                                <van-col span="4" class="trade">
                                    {{ item.amount }}
                                </van-col>
                                <van-col span="4" class="trade">
                                    {{ item.type_text }}
                                </van-col>
                            </van-row>
                        </div>
                    </div>
                    <div class="table" v-if="active == 4">
                        <!-- 表头 -->
                        <van-row class="header">
                            <van-col span="4" class="vanItem">{{ $t('币种') }}</van-col>
                            <van-col span="4" class="vanItem">{{ $t('机器人ID') }}</van-col>
                            <van-col span="4" class="vanItem">{{ $t('投入金额') }}</van-col>
                            <van-col span="4" class="vanItem">{{ $t('总收益') }}</van-col>
                            <van-col span="4" class="vanItem">{{ $t('网格数量') }}</van-col>
                            <van-col span="4" class="vanItem">{{ $t('服务费') }}</van-col>
                        </van-row>
                        <!-- 数据 -->
                        <div class="scroll">
                            <van-row v-for="item in orderList" :key="item.id" class="row">
                                <van-col span="4" class="trade">
                                    {{ item.name }}
                                </van-col>
                                <van-col span="4" class="trade">
                                    {{ item.id }}
                                </van-col>
                                <van-col span="4" class="trade">
                                    {{ item.amount }}
                                </van-col>
                                <van-col span="4" class="trade">
                                    {{ item.totalincome }}
                                </van-col>
                                <van-col span="4" class="trade">
                                    {{ item.number }}
                                </van-col>
                                <van-col span="4" class="trade">
                                    {{ item.commission }}
                                </van-col>
                            </van-row>
                        </div>
                    </div>
                    <div class="table" v-if="active == 5">
                        <!-- 表头 -->
                        <van-row class="header">
                            <van-col span="4" class="vanItem">{{ $t('币种') }}</van-col>
                            <van-col span="4" class="vanItem">{{ $t('方向') }}</van-col>
                            <van-col span="4" class="vanItem">{{ $t('委托总量') }}</van-col>
                            <van-col span="4" class="vanItem">{{ $t('委托价格') }}</van-col>
                            <van-col span="4" class="vanItem">{{ $t('手续费') }}</van-col>
                            <van-col span="4" class="vanItem">{{ $t('成交均价') }}</van-col>
                        </van-row>
                        <!-- 数据 -->
                        <div class="scroll">
                            <van-row v-for="item in orderList" :key="item.id" class="row">
                                <van-col span="4" class="trade">
                                    {{ item.title }}
                                </van-col>
                                <van-col span="4" class="trade" style="color: aqua;">
                                    {{ item.direction_text }}
                                </van-col>
                                <van-col span="4" class="trade">
                                    {{ item.quantity }}
                                </van-col>
                                <van-col span="4" class="trade">
                                    {{ item.amount }}
                                </van-col>
                                <van-col span="4" class="trade">
                                    {{ item.fee }}
                                </van-col>
                                <van-col span="4" class="trade">
                                    {{ item.charge_price }}
                                </van-col>
                            </van-row>
                        </div>
                    </div>
                    <div class="table" v-if="active == 6">
                        <!-- 表头 -->
                        <van-row class="header">
                            <van-col span="7" class="vanItem">{{ $t('投资组合') }}</van-col>
                            <van-col span="7" class="vanItem">{{ $t('申请金额') }}</van-col>
                            <van-col span="5" class="vanItem">{{ $t('当前收益') }}</van-col>
                            <van-col span="5" class="vanItem">{{ $t('状态') }}</van-col>
                        </van-row>
                        <!-- 数据 -->
                        <div class="scroll">
                            <van-row v-for="item in orderList" :key="item.id" class="row">
                                <van-col span="7" class="trade">
                                    {{ item.title }}
                                </van-col>
                                <van-col span="7" class="trade" style="color: aqua;">
                                    {{ item.amount }}
                                </van-col>
                                <van-col span="5" class="trade" style="color: aqua;">
                                    {{ item.profit }}
                                </van-col>
                                <van-col span="5" class="trade">
                                    {{ item.status }}
                                </van-col>
                            </van-row>
                        </div>
                    </div>
                </div>
            </van-tab>
        </van-tabs>
    </div>
</template>
<script>
export default {
    props: {
        totalS: {
            type: String,
            default: ''
        },
        orderList: {
            type: Array,
            default: () => []
        },
        dataList: {
            type: Array,
            default: () => []
        },
        objectS: {
            type: Object,
            default: () => { }
        }
    },

    data() {
        return {
            active: 0,
        };
    },
    mounted() {
    },
    beforeUnmount() { },
    methods: {
        onChange(name, title) {
            console.log("切换到", name, title)
            this.$emit('orderData', name + 1)
        }
    },
};
</script>
<style lang="less" scoped>
.idS {
    color: #fff;
    padding: 0 10px;
    margin-bottom: 20px;
    font-size: 14px;
    border: 1px solid #2b2b3d;
    margin-top: 15px;
    border-radius: 10px;

    .overview {
        padding: 10px 0;
        padding-bottom: 0;

        .amount {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 0;
            margin-top: 10px;
            font-size: 12px;

            .rowItem {
                text-align: center;

                div:nth-child(2) {
                    padding-top: 4px;
                    font-size: 20px;
                }
            }
        }

        .total {
            color: #888;

            span {
                color: #fff;
                padding: 0 4px;
            }
        }

        .table {
            color: #fff;
            margin-top: 10px;
            font-size: 12px;
            border-bottom: 1px solid #2b2b3d;

            .header {
                padding: 10px 0;
                border-bottom: 1px solid #222b39;

                .vanItem {
                    text-align: center;
                }
            }

            .scroll {
                overflow-y: auto;
                height: 52vh;
                scrollbar-width: none;
                /* Firefox */
                -ms-overflow-style: none;
                /* IE/Edge */
            }

            .row {

                padding: 10px 0px;
                display: flex;
                align-items: center;
                font-size: 11px;

                .trade {
                    text-align: center;
                }

                .rowItem {
                    display: flex;
                    align-items: center;
                }


            }
        }

    }
}
</style>
